import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { ProblemSection } from '../components/ProblemSection';
import { FailedApproachesSection } from '../components/FailedApproachesSection';
import { MechanismSection } from '../components/MechanismSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-cream" data-id="element-117">
      <HeroSection data-id="element-118" />
      <OpeningHookSection data-id="element-119" />
      <ProblemSection data-id="element-120" />
      <FailedApproachesSection data-id="element-121" />
      <MechanismSection data-id="element-122" />
      <DeliverablesSection data-id="element-123" />
      <AudienceSection data-id="element-124" />
      <HowItWorksSection data-id="element-125" />
      <ProofSection data-id="element-126" />
      <FAQSection data-id="element-127" />
      <OfferSection data-id="element-128" />
      <Footer data-id="element-129" />
    </main>;
}